import * as css from './Boxoffice.css';
import {useTranslation} from 'react-i18next';
import AccountPermission from '../../pages/components/accountPermission/AccountPermission';
import setGlobalState from '../../redux/setGlobalState';
import Tooltip from '../../component/tooltip/Tooltip';
import EventRolePermission from '../../pages/components/rolePermission/EventRolePermission';

function Boxoffice({className}) {
    const {t} = useTranslation('layout');

    return (
        <AccountPermission permission="boxoffice" >
            <EventRolePermission rolePermission={'boxoffice'} views={[]} >
                <Tooltip text={t('boxOffice')}>
                    <css.boxOffice className={className && className} onClick={() => setGlobalState('ui.newIframe.openBoxoffice', true)} />
                </Tooltip>
            </EventRolePermission>
        </AccountPermission>

    );
}
export default Boxoffice;